/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_box_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Box Plot Maker (Box-and-Whisker, Free) — Toolverse`)
};

const es_box_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador de Diagramas de Caja (Caja y Bigotes, Gratis) — Toolverse`)
};

const de_box_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Box-Plot-Ersteller (Box-Whisker-Diagramm, Kostenlos) — Toolverse`)
};

const nl_box_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boxplotmaker (box-and-whisker, gratis) — Toolverse`)
};

const fr_box_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur de boîte à moustaches (gratuit) — Toolverse`)
};

const it_box_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore di box plot (a scatola e baffi, gratuito) — Toolverse`)
};

const pt_br2_box_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Boxplot (Diagrama de Caixa, Grátis) — Toolverse`)
};

const pt_box_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador de Diagramas de Extremos e Quartis (Grátis) — Toolverse`)
};

const ja_box_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`箱ひげ図作成ツール（無料） — Toolverse`)
};

const zh_box_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`箱线图制作工具（箱须图，免费）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const box_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.box_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("box_meta_title", locale)
	if (locale === "en") return en_box_meta_title(inputs)
	if (locale === "es") return es_box_meta_title(inputs)
	if (locale === "de") return de_box_meta_title(inputs)
	if (locale === "nl") return nl_box_meta_title(inputs)
	if (locale === "fr") return fr_box_meta_title(inputs)
	if (locale === "it") return it_box_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_box_meta_title(inputs)
	if (locale === "pt") return pt_box_meta_title(inputs)
	if (locale === "ja") return ja_box_meta_title(inputs)
	return zh_box_meta_title(inputs)
};